import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

import {CreateNewDevice} from '../pages/create-new-device/CreateNewDevice'
import {CreateNewParameter} from '../pages/create-new-parameter/CreateNewParameter'
import {DeviceDetail} from '../pages/device-detail/DeviceDetail'
import {ParameterDetail} from '../pages/parameter/ParameterDetail'
import {UserManagementWrapper} from '../pages/user-management/UserManagementWrapper'
import {MyProfileWrapper} from '../pages/my-profile/MyProfileWrapper'
import {VBoxCreateNewParameter} from '../pages/device-detail/component/component/VBoxCreateNewParameter'
import {DeviceNoteWrapper} from '../pages/device-note/DeviceNoteWrapper'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='create-new-device' element={<CreateNewDevice />} />
        <Route path='device/:deviceId' element={<DeviceDetail />} />
        <Route path='create-new-parameter/:deviceId' element={<CreateNewParameter />} />
        <Route
          path='create-new-parameter-vbox-import/:deviceId'
          element={<VBoxCreateNewParameter />}
        />
        {/* <Route path='parameter/:parameterId' element={<ParameterDetail />} /> */}
        <Route path='device/:deviceId/parameter/:parameterId' element={<ParameterDetail />} />
        <Route path='user-management' element={<UserManagementWrapper />} />
        <Route path='device-note' element={<DeviceNoteWrapper />} />

        <Route path='my-profile' element={<MyProfileWrapper />} />

        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
